import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'lib-canvas-request-access-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './canvas-request-access-modal.component.html',
  styleUrl: './canvas-request-access-modal.component.scss',
})
export class CanvasRequestAccessModalComponent implements OnChanges {
  @Input() visible = false;
  @Input() userHasOrganisation = false;
  @Input() organisationName = '';
  /** When false, modal does not close on submit; parent should close on success. */
  @Input() closeOnSubmit = true;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() requestAccessSubmit = new EventEmitter<{
    requestAs: string;
    purposeDescription: string;
    agreeToTerms: boolean;
    organisationName?: string;
  }>();

  requestAs = 'Individual';
  purposeDescription = '';
  agreeToTerms = false;

  get purposeDescriptionLength(): number {
    return this.purposeDescription.length;
  }

  get isFormValid(): boolean {
    if (this.requestAs === 'Organisation' && !this.userHasOrganisation) {
      return false;
    }
    return this.purposeDescription.trim().length > 0 && this.agreeToTerms;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && !this.visible) {
      this.resetForm();
    }
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('cv-ra-backdrop')) {
      this.onClose();
    }
  }

  onClose(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.resetForm();
  }

  onSubmit(): void {
    if (!this.isFormValid) return;

    const formData = {
      requestAs: this.requestAs,
      purposeDescription: this.purposeDescription,
      agreeToTerms: this.agreeToTerms,
      ...(this.userHasOrganisation && { organisationName: this.organisationName }),
    };

    this.requestAccessSubmit.emit(formData);
    if (this.closeOnSubmit) {
      this.onClose();
    }
  }

  goToJoinOrganisation(): void {
    this.onClose();
    window.location.href = '/consumer/join-organisation';
  }

  private resetForm(): void {
    this.requestAs = 'Individual';
    this.purposeDescription = '';
    this.agreeToTerms = false;
  }
}
